import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { VSLeadsIntegrationsNew } from '@/components/vsleads/VSLeadsIntegrationsNew';
import { VSLeadsIntegrationsTest } from '@/components/vsleads/VSLeadsIntegrationsTest';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';

export default function VSLeadsIntegration() {
  useLanguage();
  const { id } = useParams();
  const navigate = useNavigate();

  console.log('=== VSLeadsIntegration PAGE ===');
  console.log('Params ID:', id);

  return (
    <Layout fixedSidebar>
      <div className="flex-1 flex flex-col bg-background overflow-hidden">
        {/* Header */}
        <div className="bg-background border-b border-[#E7E9EF] px-4 lg:px-[60px] py-6">
          <div className="max-w-[1320px] mx-auto">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate('/vsleads')}
                className="text-[#6B7280] hover:text-[#111827]"
              >
                <ChevronLeft className="h-4 w-4 mr-2" />
                {translateInterfaceText("Voltar")}</Button>

              <div className="flex-1">
                <h1 className="text-[26px] font-semibold text-foreground">
                  {translateInterfaceText("Integrações")}</h1>
                <p className="text-[14px] text-[#6B7280] mt-1">
                  {translateInterfaceText("Configure integrações para enviar seus leads capturados")}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto" style={{ scrollbarWidth: 'thin', scrollbarColor: '#C5C5C5 transparent' }}>
          <div className="px-4 lg:px-[60px] py-8 max-w-[1320px] mx-auto">
            {/* Componente de teste - remover depois */}
            <div className="mb-8">
              <VSLeadsIntegrationsTest />
            </div>

            <hr className="my-8" />

            {/* Componente real */}
            <VSLeadsIntegrationsNew strategyId={id} />
          </div>
        </div>
      </div>
    </Layout>
  );
}
